import { render, staticRenderFns } from "./Anggota.vue?vue&type=template&id=07d5156b&scoped=true&"
import script from "./Anggota.vue?vue&type=script&lang=js&"
export * from "./Anggota.vue?vue&type=script&lang=js&"
import style0 from "./Anggota.vue?vue&type=style&index=0&id=07d5156b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5156b",
  null
  
)

export default component.exports